import styled from "styled-components";
import { Component, useContext, useEffect, useState } from "react";
import ListSizeSetter from "../../helperComponents/ListSizeSetter";
import LoadingSection from "../../helperComponents/LoadingSection";
import CustomMasonry from "../../helperComponents/CustomMasonry";
import CustomPagination from "../../helperComponents/CustomPagination";
import { serverLine } from "../../../controllers/network/serverLine";
import CustomButton from "../../helperComponents/CustomButton";
import LoggedInBoilerplate from "../../pages/loggedIn/LoggedInBoilerplate";
import Context from "../../../Context";
import PermissionDeniedPage from "../PermissionDeniedPage";
import CustomLabel from "../CustomLabel";
import { BiExport, BiFilter, BiReset } from "react-icons/bi";
import exportFunction from "../../../controllers/customControllerForCS/exportFunction";
import MaterialInput from "../../helperComponents/MaterialInput";
import FieldsSelectorPopup from "./FieldsSelectorPopup";
import AssignmentHistoryTable from "./TableRenderForAH";
import TableRenderForAH from "./TableRenderForAH";
import AssignmentHistoryCardForProfilePage from "../../pages/loggedIn/assignmentHistory/AssignmentHistoryCardForProfilePage";
import AssignmentHistoryTableForProfile from "./AssignmentHistoryTableForProfile";
import CustomLabelDim from "../CustomLabelDim";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  width: 100%;
  /* margin-top: 30px; */
  padding: 20px;
  border-radius: 10px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 10px;
`;

const Filters = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const SearchContainer = styled.div`
  width: 300px;
`;

const Content = styled.div`
  /* 
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--surface2); 
  */
  //
  //
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
  min-height: 500px;
  animation: centerScaleReveal 0.4s ease-in-out forwards;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export default function AssignmentHistoryForUserProfile({
  userID,
  path = "assignment-history",
  queryParams,
  nothingFoundMessage,
}) {
  const [currentPage, setCurrentPage] = useState(0);
  const [maxPages, setMaxPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("queryParams changed", queryParams);
    setCurrentPage(0);
    doQuery(0);
  }, [itemsPerPage, queryParams]);

  if (!nothingFoundMessage) nothingFoundMessage = "cette liste est vide"; //This list is empty

  let core = null;

  if (loading) {
    core = <LoadingSection />;
  } else {
    core = <AssignmentHistoryTableForProfile items={items} />;

    if (!items.length) {
      core = <CustomLabelDim>{nothingFoundMessage}</CustomLabelDim>;
    }
  }

  return (
    <Container>
      <CustomLabel>Assignment History</CustomLabel>

      <Content>{core}</Content>

      {loading ? null : (
        <BottomPart>
          <ListSizeSetter value={itemsPerPage} onChange={setItemsPerPage} />
          <CustomPagination
            value={currentPage}
            max={maxPages}
            onChange={doQuery}
          />
        </BottomPart>
      )}
    </Container>
  );

  function getThePath(newPage) {
    // if (!newPage) newPage = currentPage; this line will cause bug for 0 page

    let more = "";

    let theParams = { ...queryParams };

    if (userID) theParams.userID = userID;

    for (let key in theParams) {
      if (theParams[key]) {
        more = more + `&${key}=${theParams[key]}`;
      }
    }

    return `/${path}/?currentPage=${newPage}&itemsPerPage=${itemsPerPage}${more}&makeFieldsReadable=true&showImage=true&allowID=true`;
  }

  function doQuery(newPage) {
    let thePath = getThePath(newPage);

    let more = "";
    for (let key in queryParams) {
      if (queryParams[key]) {
        more = more + `&${key}=${queryParams[key]}`;
      }
    }

    setLoading(true);
    setCurrentPage(newPage);
    serverLine.get(thePath).then((newData) => {
      setLoading(false);
      setItems(newData.list);
      setMaxPages(newData.maxPages);
    });
  }
}
